import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Box, Tooltip } from "@mui/material"
import { cloneElement } from "react"

export function RegimeDraftLockTooltip({ children, disableTitle = false, additionalCheck }) {
    const { isRegimeDraftLocked } = useBoundContext()

    const isLocked = additionalCheck === undefined ? isRegimeDraftLocked : isRegimeDraftLocked && additionalCheck

    const disabledChild = cloneElement(children, { disabled: true, readOnly: true })

    return (
        <If truthy={isLocked}>
            <Tooltip title={!disableTitle ? "Locked while under review" : ""}>
                <Box>{disabledChild}</Box>
            </Tooltip>
            <Else>{children}</Else>
        </If>
    )
}
